import React from 'react'
import { SortableElement } from 'react-sortable-hoc'
import { IGroupDetailed } from '../../../types/group'
import { ReorderTableRow } from './ReorderTableRow'

const SortableItem = SortableElement(ReorderTableRow)

export interface IReorderTableBodyComponent {
  list: IGroupDetailed[]
}

export const ReorderTableBody: React.FC<IReorderTableBodyComponent> = ({
  list,
}) => (
  <tbody>
    {list.map((group, index) => (
      <SortableItem key={`item-${index}`} index={index} group={group} />
    ))}
  </tbody>
)
